import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import OffersPreviewDialog from "./OffersPreviewDialog";

export default function OffersPreviewPage() {
  const { id } = useParams();
  const [offer, setOffer] = useState(null);
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // جلب بيانات العرض من API هنا لاحقاً
    setOffer({
      id: id,
      name: "عرض كوبون",
      store: { name_ar: "المنافس" },
      promotion_type: { name: "coupons" },
      start_date: "2025-06-25T21:00:00.000000Z",
      end_date: "2025-06-29T21:00:00.000000Z",
      is_super_offer: true,
      gift_types: [
        {
          id: 1,
          name: "fixed_discount",
          relationship: { value: "20.00" },
        },
      ],
    });
  }, [id]);

  const handleClose = () => {
    setOpen(false);
    // navigate(-1);
  };

  return <OffersPreviewDialog open={open} onClose={handleClose} offer={offer} />;
}
